<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnToggle
 */
import type { BtnToggleProps } from '../types/interfaces'

import { AppTooltip } from '@shared/ui/tooltips'

import { useBtnToggle } from '../composables/use-btn-toggle.hook'

defineOptions({
  name: 'BtnToggle',
})

const props = withDefaults(defineProps<BtnToggleProps>(), {
  tooltipText: '',
  tooltipPosition: 'bottom',
  color: 'blue',
  checked: false,
  disabled: false,
  readonly: false,
})

const emit = defineEmits<{
  click: [boolean]
}>()

const {
  checkedValue,
  handleClick,
} = useBtnToggle({
  props,
  onClick: (value) => emit('click', value),
})
</script>

<template>
  <AppTooltip
    v-if="tooltipText"
    :text="tooltipText"
    :placement="tooltipPosition"
  >
    <button
      :class="['ui-btn-toggle', color, { checked: checkedValue, disabled }]"
      :disabled="disabled"
      @click="handleClick"
    >
      <span class="ui-btn-toggle__circle" />
    </button>
  </AppTooltip>
  <button
    v-else
    :class="['ui-btn-toggle', color, { checked: checkedValue, disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="ui-btn-toggle__circle" />
  </button>
</template>

<style lang="scss" scoped src="../styles/_btn-toggle.scss" />
